
export interface CountryRef {
	id: string;
}

export interface ContactInfoRef {
	id: string;
}

// Main ContactInfo interfaces
export interface ContactInfo {
	id: string;
	name?: string;
	email?: string;
	phone?: string;
	whatsapp?: string;
	address?: string;
	city?: string;
	state?: string;
	postalCode?: string;
	weekdayHours?: string;
	weekendHours?: string;
	vatNumber?: string;
	country?: CountryRef;
	createdAt?: string;
	updatedAt?: string;
}

export interface ContactInfoCreateDto {
	name?: string;
	email?: string;
	phone?: string;
	whatsapp?: string;
	address?: string;
	city?: string;
	state?: string;
	postalCode?: string;
	weekdayHours?: string;
	weekendHours?: string;
	vatNumber?: string;
	country?: CountryRef;
}

export interface ContactInfoUpdateDto {
	name?: string;
	email?: string;
	phone?: string;
	whatsapp?: string;
	address?: string;
	city?: string;
	state?: string;
	postalCode?: string;
	weekdayHours?: string;
	weekendHours?: string;
	vatNumber?: string;
	country?: CountryRef;
}

// Backend response interfaces that match the actual API
export interface ContactInfoBackendResponse {
	id: string;
	name?: string;
	email?: string;
	phone?: string;
	whatsapp?: string;
	address?: string;
	city?: string;
	state?: string;
	postalCode?: string;
	weekdayHours?: string;
	weekendHours?: string;
	vatNumber?: string;
	country?: {
		id: string;
		name: string;
		code: string;
	};
	createdAt: string;
	updatedAt: string;
}

// Paginated response interface
export interface ContactInfoPaginatedResponse {
	data: ContactInfoBackendResponse[];
	hasNextPage: boolean;
	hasPreviousPage: boolean;
	page: number;
	limit: number;
	totalCount: number;
}

// Redux state interface
export interface ContactInfoState {
	items: ContactInfoBackendResponse[];
	current: ContactInfoBackendResponse | null;
	loading: boolean;
	error: string | null;
	totalCount?: number;
	hasNextPage?: boolean;
	hasPreviousPage?: boolean;
	page?: number;
	limit?: number;
}

// Contact Us interfaces
export interface ContactUsType {
	id: number;
	name: string;
}

export interface ContactUs {
	id: number;
	name?: string;
	email?: string;
	subject?: string;
	message?: string;
	type?: ContactUsType;
	createdAt: string;
	updatedAt: string;
}

export interface ContactUsCreateDto {
	name?: string;
	email?: string;
	subject?: string;
	message?: string;
	type?: {
		id: number;
	};
}

export interface ContactUsUpdateDto {
	name?: string;
	email?: string;
	subject?: string;
	message?: string;
	type?: {
		id: number;
	};
}

export interface ContactUsBackendResponse {
	id: number;
	name?: string;
	email?: string;
	subject?: string;
	message?: string;
	type?: ContactUsType;
	createdAt: string;
	updatedAt: string;
}

export interface ContactUsPaginatedResponse {
	data: ContactUsBackendResponse[];
	hasNextPage: boolean;
	hasPreviousPage: boolean;
	page: number;
	limit: number;
	totalCount: number;
}

export interface ContactUsState {
	items: ContactUsBackendResponse[];
	current: ContactUsBackendResponse | null;
	loading: boolean;
	error: string | null;
	totalCount?: number;
	hasNextPage?: boolean;
	hasPreviousPage?: boolean;
	page?: number;
	limit?: number;
}

// Social Link Type Enum
export enum SocialLinkTypeEnum {
	Terms_Conditions = 1,
	Help_Center = 2,
}

// Social Links interfaces
export interface SocialLink {
	id: string;
	facebook?: string;
	twitter?: string;
	instagram?: string;
	linkedin?: string;
	youtube?: string;
	type?: {
		id: SocialLinkTypeEnum;
	};
	createdAt: string;
	updatedAt: string;
}

export interface SocialLinkCreateDto {
	facebook?: string;
	twitter?: string;
	instagram?: string;
	linkedin?: string;
	youtube?: string;
	tiktok?: string;
	type?: {
		id: SocialLinkTypeEnum;
	};
}

export interface SocialLinkUpdateDto {
	facebook?: string;
	twitter?: string;
	instagram?: string;
	linkedin?: string;
	youtube?: string;
	tiktok?: string;
	type?: {
		id: SocialLinkTypeEnum;
	};
}

export interface SocialLinkBackendResponse {
	id: string;
	facebook?: string;
	twitter?: string;
	instagram?: string;
	linkedin?: string;
	youtube?: string;
	tiktok?: string;
	type?: {
		id: SocialLinkTypeEnum;
	};
	createdAt: string;
	updatedAt: string;
}

export interface SocialLinkPaginatedResponse {
	data: SocialLinkBackendResponse[];
	hasNextPage: boolean;
	hasPreviousPage: boolean;
	page: number;
	limit: number;
	totalCount: number;
}

export interface SocialLinkState {
	items: SocialLinkBackendResponse[];
	current: SocialLinkBackendResponse | null;
	loading: boolean;
	error: string | null;
	totalCount?: number;
	hasNextPage?: boolean;
	hasPreviousPage?: boolean;
	page?: number;
	limit?: number;
}
